<template>
  <div class="courses-container">
    <div class="course-list" v-if="courses.length > 0">
      <div class="course-item" v-for="(course,index) in courses" :key="index" @click="goToDetail(course)">
        <div class="order-header">
          订单编号：{{ course.orderId }}
        </div>
        <div class="course-content">
          <div class="course-img-wrapper">
            <img :src="course.image" alt="Course Image" />
          </div>
          <div class="course-info">
            <h3 class="course-title">{{ course.title }}</h3>
            <div class="course-price">¥ {{ course.price }}</div>
          </div>
          <div class="course-action">
            <button class="learn-btn">
              <span class="play-icon">▶</span> 去学习
            </button>
          </div>
        </div>
      </div>
    </div>
    <empty-state v-else description="暂无课程"></empty-state>
  </div>
</template>

<script>
import { getOrderList } from '@/api/order'
import EmptyState from '@/components/EmptyState.vue'

export default {
  name: 'MyCourses',
  components: {
    EmptyState
  },
  data() {
    return {
      courses: []
    }
  },
  created() {
    this.fetchOrderList()
  },
  methods: {
    goToDetail(course) {
      console.log( course.extra)
					this.$router.push({
						name: 'CourseDetail',
						params: {
							id: course.extra.courseId
						}
					})
			},
    async fetchOrderList() {
      try {
        const res = await getOrderList({
          goodsType: 1,
          payStatus: 1
        })
        const list = res.rows || res.data || res
        if (Array.isArray(list)) {
          this.courses = list.map(item => ({
            id: item.id || item.orderId,
            orderId: item.orderNo || item.orderId,
            title: item.productName || item.title || item.goodsName,
            price: item.amount,
            image: item.extra.coverImg,
            extra:item.extra
          }))
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.courses-container {
  /* No background color for the container itself to let cards float */
  width: 100%;
}

.course-list {
  display: flex;
  flex-direction: column;
  gap: 20px;

  .course-item {
    background-color: #1e1e1e; /* Match sidebar background */
    border-radius: 8px;
    padding: 20px 30px; /* More horizontal padding */
    
    .order-header {
      color: #999;
      font-size: 14px;
      margin-bottom: 20px;
      padding-bottom: 15px;
      border-bottom: 1px dashed #444; /* Dashed separator */
    }

    .course-content {
      display: flex;
      align-items: center;
      gap: 20px;

      .course-img-wrapper {
        width: 180px; /* Slightly larger */
        height: 100px;
        border-radius: 6px;
        overflow: hidden;
        flex-shrink: 0;
        background-color: #333;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .course-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 90px;
        padding: 5px 0;

        .course-title {
          color: #ddd;
          font-size: 16px;
          font-weight: normal;
          margin: 0;
          letter-spacing: 0.5px;
        }

        .course-price {
          color: #dcb46e; /* Gold color */
          font-size: 20px;
          font-family: 'Arial', sans-serif;
        }
      }

      .course-action {
        align-self: flex-end; /* Align to bottom if needed, or center */
        align-self: center;

        .learn-btn {
          background-color: #2a2a2a; /* Darker button background */
          color: #ff9900;
          border: none;
          padding: 8px 24px;
          border-radius: 20px; /* Pill shape */
          cursor: pointer;
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.3s;
          font-weight: bold;

          .play-icon {
            font-size: 12px;
          }

          &:hover {
            background-color: #333;
            transform: translateY(-1px);
          }
        }
      }
    }
  }
}
</style>
